import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useCreateChildPerfMarker } from '@bingads-webui-campaign-react/performance-marker-provider';
import { BannerServiceProvider, CopilotRepositoryProvider } from '@bingads-webui/inline-copilot';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const FAKE_CMP_ID = '0';

export const withCopilotProvider = WrappedComponent => React.memo((props) => {
  const serverContext = useContext(ServerContext);
  const scopeContext = useContext(ScopeContext);
  const i18n = useContext(I18nContext);

  let campaignId = useMemo(() => _.get(scopeContext, ['scope', 'values', 'campaignId']), [scopeContext]);
  if (!campaignId && isSDK()) {
    campaignId = FAKE_CMP_ID;
  }

  const onboardingUrl = useMemo(() => _.get(props, ['data', 'onboardingUrl'], ''), [props]);
  const finalUrl = useMemo(() => _.get(props, ['data', 'assetGroupData', 'FinalUrlForRecommendation'], onboardingUrl), [props, onboardingUrl]);

  const perfMarker = useCreateChildPerfMarker('PmaxLiteCopilotRecommendations');

  return (
    <CopilotRepositoryProvider
      campaignId={campaignId}
      finalUrl={finalUrl}
      locale={i18n.getLocale()}
      perfMarker={perfMarker}
      recommendationType="PMax"
      serverContext={serverContext}
    >
      <BannerServiceProvider>
        <WrappedComponent {...props} />
      </BannerServiceProvider>
    </CopilotRepositoryProvider>
  );
});
